import Alpine from 'alpinejs'
import combobox from '@alpinejs/ui/src/combobox';

import { tns } from 'tiny-slider';

window.Alpine = Alpine;

Alpine.plugin((Alpine) => {
    combobox(Alpine);
});

Alpine.data('AirportInput', () => ({
    selected: null,
    airports: [],
    async fetchAirports(query) {
        if (query.length < 3) {
            this.airports = [];
        } else {
            const response = await fetch('https://api.flywize.eu/graphql', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: `
                        query FindAirport {
                            findAirport(search: "${query}") {
                                id
                                name
                                iataCode
                                city {
                                    name
                                    country {
                                        name
                                    }
                                }
                            }
                        }
                    `,
                }),
            });

            this.airports = (await response.json()).data.findAirport;
        }
    },
}));

Alpine.data('Dropdown', () => ({
    open: false,

    root: {
        ['x-on:keydown.escape.prevent.stop']() {
            this.closeDropdown(this.$refs.button)
        },
        ['x-on:focusin.window'](event) {
            ! this.$refs.panel.contains(event.target) && this.closeDropdown()
        },
    },

    trigger: {
        type: 'button',

        'x-ref': 'button',
        ['@click']() {
            this.toggleDropdown();
        },
    },

    panel: {
        'x-ref': 'panel',
        ['x-show']() {
            return this.open
        },
        ['x-on:click.outside']() {
            this.closeDropdown(this.$refs.button)
        }
    },

    toggleDropdown() {
        if (this.open) {
            return this.closeDropdown()
        }

        this.$refs.button.focus()

        this.open = true
    },
    closeDropdown(focusAfter = null) {
        if (! this.open) return

        this.open = false

        focusAfter && focusAfter.focus()
    },
}));

Alpine.data('Slider', () => ({
    slider: null,
    currentIndex: 1,
    pages: 0,

    init() {
        this.slider = tns({
            container: this.$refs.slider,
            mouseDrag: true,
            loop: false,
            items: 1,
            gutter: 24,
            controls: false,
            nav: false,
            responsive: {
                1024: {
                    items: 2
                }
            }
        });

        this.updateControls();

        this.slider.events.on('indexChanged', () => this.updateControls());
    },

    prev: {
        ['@click']() {
            this.slider.goTo('prev');
        },
        [':disabled']() {
            return this.currentIndex === 1;
        }
    },

    next: {
        ['@click']() {
            this.slider.goTo('next');
        },
        [':disabled']() {
            return this.currentIndex === this.pages;
        }
    },

    updateControls() {
        const info = this.slider.getInfo();

        this.currentIndex = info.displayIndex;
        this.pages = info.pages;

        console.log(info);
    }
}))

Alpine.start();

// Persist inbound marketing source across navigation and onto flywize forms.
document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);
    const paramSource = params.get('utm_source') || params.get('source');

    if (paramSource) {
        localStorage.setItem('flywize_source', paramSource);
    }

    const source = paramSource || localStorage.getItem('flywize_source');

    if (!source) {
        return;
    }

    document
        .querySelectorAll('form[action*="my.flywize"]')
        .forEach((form) => {
            ['utm_source'].forEach((name) => {
                let input = form.querySelector(`input[name="${name}"]`);

                if (!input) {
                    input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = name;
                    form.appendChild(input);
                }

                input.readOnly = true;
                input.value = source;
            });
        });

    document
        .querySelectorAll('a[href*="my.flywize"]')
        .forEach((anchor) => {
            try {
                const url = new URL(anchor.href, window.location.origin);
                if (!url.searchParams.get('utm_source') && !url.searchParams.get('source')) {
                    url.searchParams.set('utm_source', source);
                }
                anchor.href = url.toString();
            } catch (e) {
                // Ignore malformed URLs
            }
        });
});
